import { render } from "./HeroSection.vue?vue&type=template&id=298996ea&scoped=true&ts=true"
import script from "./HeroSection.vue?vue&type=script&lang=ts"
export * from "./HeroSection.vue?vue&type=script&lang=ts"

import "./HeroSection.vue?vue&type=style&index=0&id=298996ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-298996ea"]])

export default __exports__